import { call, putResolve, take } from 'redux-saga/effects';

import { API } from 'app/api';
import { getClientInfo } from 'app/lib/account/actions';
import { logout } from 'app/redux/actions/auth';

import { getSiteConfigs } from './service';
import { changeConfigValue } from './slice';

export function* siteConfigsSaga() {
  while (true) {
    yield take([getClientInfo.rejected.type, getClientInfo.fulfilled.type, logout.fulfilled.type]);

    try {
      yield putResolve(getSiteConfigs());
    }
    catch (error) {
      console.error(`siteConfigsSaga: error = ${error}`);
    }
  }
}

const submitSiteConfig = ({ name, value }) => {
  return API.siteConfigs.changeSiteConfig(name, value);
};

export function* changeSiteConfigSaga() {
  while (true) {
    const { payload } = yield take([changeConfigValue.type]);

    try {
      yield call(submitSiteConfig, payload);
    }
    catch (error) {
      console.error(`changeSiteConfigSaga: error = ${error}`);
    }
  }
}
